import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { u as e } from "./index-6a632112.mjs";
import { s as n, a as r, d as s, h as u, e as c } from "./themes-5f0b3c3d.mjs";
import { l } from "./lineHeights-72d3110c.mjs";
import { a as y, c as v, b as S } from "./superScript-393c70dc.mjs";
import "react";
import { h as T } from "./hTag-40b23797.mjs";
import { Button as W } from "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
const C = e.div`
  display: flex;
  flex-direction: column;
  gap: ${n["6x"]};
`, D = e.div`
  display: flex;
  flex-direction: column;
  gap: ${n["2x"]};
`, b = e(T)`
  font-size: ${r.small};
  font-family: ${s.headline};
  font-weight: ${u.S.fontWeight};
  line-height: ${l.medium};
  color: ${(t) => t.theme.components.textDisclosure.titleColor};
`, z = e.div`
  display: flex;
  gap: ${n["2x"]};
`, w = e.div`
  color: ${(t) => t.theme.components.textDisclosure.titleColor};
  font-size: ${r.xxsmall};
  font-family: ${s.body};
  font-weight: ${c.regular.XS.fontWeight};
  line-height: ${l.xsmall};
`, B = e.div`
  ${y()}
  ${v()}
  ${S()}
  display: flex;
  flex-direction: column;
  gap: ${n["1x"]};
  font-size: ${r.xxsmall};
  font-family: ${s.body};
  font-weight: ${c.regular.XS.fontWeight};
  line-height: ${l.xsmall};
  color: ${(t) => t.theme.components.textDisclosure.contentColor};
`, j = e(W)`
  font-size: ${r.xxsmall} !important;
  padding: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  height: unset !important;
  border: unset !important;
  line-height: ${l.xsmall} !important;
  &:hover {
    background: transparent !important;
    color: ${(t) => t.theme.components.textDisclosure.linkHoverColor} !important;
    text-decoration: underline;
  }
`, J = ({
  titleProp: t = {
    title: "Disclosure(s)",
    headingLevel: "h2"
  },
  disclosureItems: h = [],
  className: d = "",
  returnToLinkTitle: f = "Return to content",
  id: p,
  ...g
}) => /* @__PURE__ */ a(C, { ...g, id: p, className: d, children: [
  /* @__PURE__ */ o(b, { as: t.headingLevel, children: t.title }),
  /* @__PURE__ */ o(D, { children: h.map(
    ({
      text: x,
      returnToLinkTitle: m,
      ...$
    }, i) => /* @__PURE__ */ a(z, { id: `${p}-item-${i + 1}`, children: [
      /* @__PURE__ */ o(w, { children: `${i + 1})` }),
      /* @__PURE__ */ a(B, { children: [
        /* @__PURE__ */ o("div", { children: x }),
        /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(j, { ...$, variant: "text", size: "small", children: m || `${f}, Disclosure ${i + 1}` }) })
      ] })
    ] }, i)
  ) })
] });
export {
  J as TextDisclosure
};
